import { render, staticRenderFns } from "./ApplicantChips.vue?vue&type=template&id=6a1bec75"
import script from "./ApplicantChips.vue?vue&type=script&lang=ts"
export * from "./ApplicantChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1bec75')) {
      api.createRecord('6a1bec75', component.options)
    } else {
      api.reload('6a1bec75', component.options)
    }
    module.hot.accept("./ApplicantChips.vue?vue&type=template&id=6a1bec75", function () {
      api.rerender('6a1bec75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/ApplicantChips.vue"
export default component.exports